
import React from 'react';
import FontSizeSelector, { FontSizeOption } from '../ui/FontSizeSelector';

const ALL_ZMANIM = [
  { key: 'alot_hashachar', label: 'עלות השחר' },
  { key: 'misheyakir', label: 'זמן טלית ותפילין המוקדם ביותר (משיכיר)' },
  { key: 'sunrise', label: 'זריחה (הנץ החמה)' },
  { key: 'sof_zman_shema_gra', label: 'סוף זמן קריאת שמע לגר"א' },
  { key: 'sof_zman_shema_mga', label: 'סוף זמן קריאת שמע למ"א' },
  { key: 'sof_zman_tefila_gra', label: 'סוף זמן תפילה לגר"א' },
  { key: 'sof_zman_tefila_mga', label: 'סוף זמן תפילה למ"א' },
  { key: 'chatzot', label: 'חצות היום' },
  { key: 'mincha_gedola', label: 'מנחה גדולה' },
  { key: 'mincha_ketana', label: 'מנחה קטנה' },
  { key: 'plag_hamincha', label: 'פלג המנחה' },
  { key: 'sunset', label: 'שקיעת החמה' },
  { key: 'tzeit_hakochavim', label: 'צאת הכוכבים' },
  { key: 'chatzot_layla', label: 'חצות הלילה' },
];

interface ZmaneyHayomEditorProps {
  content: any;
  onContentChange: (field: string, value: any) => void;
}

const ZmaneyHayomEditor: React.FC<ZmaneyHayomEditorProps> = ({ content, onContentChange }) => {
  const selected = content?.selectedZmanim || ALL_ZMANIM.map(z => z.key);
  const fontSize: FontSizeOption = content?.fontSize || 'md';

  const handleToggle = (key: string) => {
    let updated: string[];
    if (selected.includes(key)) {
      updated = selected.filter(k => k !== key);
    } else {
      updated = [...selected, key];
    }
    onContentChange('selectedZmanim', updated);
  };

  const handleFontSizeChange = (value: FontSizeOption) => {
    onContentChange('fontSize', value);
  };

  return (
    <div>
      <h3 className="font-bold mb-2">בחר אילו זמנים להציג</h3>
      <FontSizeSelector value={fontSize} onChange={handleFontSizeChange} label="גודל גופן לכרטיסים" />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {ALL_ZMANIM.map(zman => (
          <label key={zman.key} className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={selected.includes(zman.key)}
              onChange={() => handleToggle(zman.key)}
            />
            <span>{zman.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ZmaneyHayomEditor;
